import http from "@/http-common";

export default class SystemService {
	getSpringProfileActive() {
		return http.get('/system/active').then(res => res.data);
	}
}